import React from 'react';
import { Stepper } from 'react-form-stepper';
import { Controller } from 'react-hook-form';
import { StepStyleDTO } from 'react-form-stepper/dist/components/Step/StepTypes';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { ClipLoader } from 'react-spinners';
import useCreateBusiness from './createBusinessStepper-hooks';
import { customersCount } from '../../Costants/costants';
import AuthInput from '../Inputs/AuthInput/authInput';
import AutoComplete from '../Inputs/AutoComplete/autoComplete';
import ArrowButton from '../ArrowButton/arrowButton';
import { ArrowButtonSides } from '../../Interfaces/componentTypes';
import FileUploader from '../FileUploader/fileUploader';
import Loading from '../Loading/loading';
import Success from '../Success/success';
import useLanguagesHooks from '../Languages/setLanguage-hooks';
import { YourLogo } from '../../Assets/Images';
import styles from './createBusiness.module.scss';


const CreateBusinessStepper: React.FC = () => {
    const {
        steps,
        errors,
        country,
        control,
        isValid,
        imageUrl,
        activeStep,
        imageLoading,
        companyLoading,
        isCompaneCreated,
        imageLoadingSuccess,
        businessTypeContnents,
        setValue,
        register,
        onSubmit,
        onNextStep,
        setCountry,
        onPrevStep,
        handleSubmit,
        onSetBusinessType,
        onVisitBusinessSite,
        handleFileInputChange,
    } = useCreateBusiness();
    const { t } = useLanguagesHooks();

    return (
        <>
            {companyLoading
                ?
                (
                    <Loading />
                )
                : isCompaneCreated ? (
                    <Success
                        buttonTitle={t('Business.Success_Btn')}
                        onClick={onVisitBusinessSite}
                        message={t('Business.Success')}
                    />
                ) :
                    <div className={styles.container}>
                        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
                            {
                                activeStep === 0 &&
                                <div className={styles.stepContainer}>
                                    <div className={styles.stepTitle}>
                                        <p>
                                            {t('Business.Step_1.Header')}
                                        </p>
                                    </div>
                                    <div className={styles.businessTypesBox}>
                                        {
                                            businessTypeContnents.map((el) => {
                                                return (
                                                    <div
                                                        key={el.value}
                                                        className={styles.businessTypeItem}
                                                        onClick={() => onSetBusinessType(el.value)}>
                                                        <img src={el.icon} alt={`${el.title}.png`} />
                                                        <p>{el.title}</p>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            }
                            {
                                activeStep === 1 &&
                                <div className={styles.stepContainer}>
                                    <div className={styles.stepTitle}>
                                        <p>
                                            {t('Business.Step_2.Header')}
                                        </p>
                                    </div>
                                    <div className={styles.step2_body}>
                                        <div className={styles.step2_form}>
                                            <div className={styles.step2_formCol}>
                                                <AuthInput
                                                    register={register}
                                                    registerName='name'
                                                    label={t('Business.Title')}
                                                    labelStyle={styles.inputLabel}
                                                    patternValue={/.*[A-Za-zÀ-ÖØ-öø-ÿԱ-Ֆա-ֆА-Яа-яҐґЄєІіЇїΆ-ώΑ-ωא-ת一-龯ぁ-ゔァ-ヾㄱ-ㅎㅏ-ㅣ가-힣].*/}
                                                    error={errors.name}
                                                />
                                                <Controller
                                                    control={control}
                                                    name='customer_count'
                                                    rules={{
                                                        required: t('Errors.Required'),
                                                    }}
                                                    render={({ field: { onChange, name, value } }) => {
                                                        return (
                                                            <div className='autocomplete'>
                                                                <AutoComplete
                                                                    value={value}
                                                                    name={name}
                                                                    onChange={(value) => {
                                                                        onChange(value)
                                                                        setValue('customer_count', value!)
                                                                    }}

                                                                    data={customersCount}
                                                                    label={t('Business.Average_Customers')}
                                                                    labelStyle={styles.inputLabel}
                                                                    error={errors.customer_count}
                                                                />
                                                            </div>
                                                        );
                                                    }}
                                                />
                                            </div>
                                            <div className={styles.step2_formCol}>
                                                <Controller
                                                    name="country"
                                                    rules={{
                                                        required: t('Errors.Required'),
                                                    }}
                                                    render={({ field: { name, onChange, value } }) => (
                                                        <div className={styles.countryDropBox}>
                                                            <p className={styles.inputLabel}>
                                                                {t('Business.Country')}
                                                            </p>
                                                            <CountryDropdown
                                                                defaultOptionLabel={t('Business.Country_Plh')}
                                                                name={name}
                                                                value={value}
                                                                onChange={(value) => {
                                                                    onChange(value)
                                                                    setCountry(value)

                                                                }}
                                                                valueType='full'
                                                            />
                                                        </div>
                                                    )}
                                                    control={control}
                                                />

                                                <Controller
                                                    name="city"
                                                    rules={{
                                                        required: t('Errors.Required'),
                                                    }}
                                                    render={({ field: { name, onChange, value } }) => (
                                                        <div className={styles.countryDropBox}>
                                                            <p className={styles.inputLabel}>
                                                                {t('Business.City')}
                                                            </p>
                                                            <RegionDropdown
                                                                country={country!}
                                                                disableWhenEmpty
                                                                defaultOptionLabel={t('Business.City_Plh')}
                                                                name={name}
                                                                value={value}
                                                                onChange={onChange}
                                                                valueType='full'
                                                            />
                                                        </div>
                                                    )}
                                                    control={control}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            }
                            {
                                activeStep === 2 &&
                                <div className={styles.stepContainer}>
                                    <div className={styles.stepTitle}>
                                        <p>
                                            {t('Business.Step_3.Header')}
                                        </p>
                                    </div>
                                    <div className={styles.step3_body}>
                                        <div className={styles.logoContainer}>
                                            {
                                                imageLoading
                                                    ?
                                                    <ClipLoader color="#aa002b" size={40} />
                                                    :
                                                    <img
                                                        src={imageUrl ?? YourLogo}
                                                        alt={`${imageUrl}.png`}
                                                        className={styles.logoImage}
                                                    />
                                            }

                                        </div>
                                        <div className={styles.buttonsBox}>
                                            <FileUploader
                                                id='logo'
                                                handleFileInputChange={handleFileInputChange}
                                                buttonTitleStyle={styles.buttonTitle}
                                                buttonStyle={`${styles.selectLogoButton}`}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                        </form>
                        <div className={styles.stepperContainer}>
                            {
                                activeStep !== 0
                                &&
                                <div className={styles.arrowButtonsRow}>
                                    <ArrowButton
                                        direction={ArrowButtonSides.Left}
                                        onClick={onPrevStep}
                                    />
                                    {
                                        activeStep === steps.length - 1
                                            ?
                                            <ArrowButton
                                                direction={ArrowButtonSides.Right}
                                                onClick={handleSubmit(onSubmit)}
                                                disable={!imageLoadingSuccess}
                                            />
                                            :
                                            <ArrowButton
                                                direction={ArrowButtonSides.Right}
                                                onClick={onNextStep}
                                                disable={!isValid}
                                            />
                                    }

                                </div>
                            }
                            <Stepper
                                steps={steps}
                                activeStep={activeStep}
                                connectorStyleConfig={{
                                    activeColor: 'rgb(56, 56, 56)',
                                    completedColor: '#aa002b',
                                    disabledColor: 'rgb(56, 56, 56)',
                                    size: 1,
                                    style: 'solid',
                                }}

                                styleConfig={{
                                    activeBgColor: '#0b2137',
                                    completedBgColor: '#aa002b',
                                } as StepStyleDTO}
                            />
                        </div>
                    </div>
            }
        </>

    )
}

export default CreateBusinessStepper
